import {
  Box,
  ColumnLayout,
  SpaceBetween,
  Grid,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import * as awsui from "@cloudscape-design/design-tokens";

const round1Images = require.context('../../../images/gallery/s5000/round1/', false);
const round2Images = require.context('../../../images/gallery/s5000/round2/', false);
const round3Images = require.context('../../../images/gallery/s5000/round3/', false);
const round4Images = require.context('../../../images/gallery/s5000/round4/', false);

export default function Gallery() {
  const { 
    activeSeriesName, setActiveSeriesName
  } = useContext(GlobalContext);

  return (
    <>
      <div style={{background: awsui.colorBackgroundCellShaded, width: "100%", paddingTop: "40px", paddingBottom: "40px"}}>
        <div className="body-content">
          <div style={{
            textAlign: "left",
          }}>
            <h3>Round 1</h3>
          </div>
          <SpaceBetween direction="vertical" size="xl">
            <PhotoProvider maskOpacity={0.8} pullClosable >
              <Grid
                disableGutters
                gridDefinition={
                  round1Images.keys().map(() => {
                    return { colspan: { default: 6, xs: 4, m: 3 } }
                  })
                }
              >  
                {round1Images.keys().map(image => (
                  <div className="liivery-grid-container">
                    <Box textAlign="center">
                      <PhotoView src={round1Images(image)}>
                        <img
                          src={round1Images(image)}
                          alt={`image-${image}`}
                          key={image}
                          style={{
                            borderRadius: "10px",
                            width: "95%"
                          }}
                        />
                      </PhotoView>
                    </Box>
                  </div>
                ))}
              </Grid>          
            </PhotoProvider>
          </SpaceBetween>
        </div>
      </div>
      <div style={{background: awsui.colorBackgroundCellShaded, width: "100%", paddingTop: "40px", paddingBottom: "40px"}}>
        <div className="body-content">
          <div style={{
            textAlign: "left",
          }}>
            <h3>Round 2</h3>
          </div>
          <SpaceBetween direction="vertical" size="xl">
            <PhotoProvider maskOpacity={0.8} pullClosable >
              <Grid
                disableGutters
                gridDefinition={
                  round2Images.keys().map(() => {
                    return { colspan: { default: 6, xs: 4, m: 3 } }
                  })
                }
              >  
                {round2Images.keys().map(image => (
                  <div className="liivery-grid-container">
                    <Box textAlign="center">
                      <PhotoView src={round2Images(image)}>
                        <img
                          src={round2Images(image)}
                          alt={`image-${image}`}
                          key={image}
                          style={{
                            borderRadius: "10px",
                            width: "95%"
                          }}
                        />
                      </PhotoView>
                    </Box>
                  </div>
                ))}
              </Grid>          
            </PhotoProvider>
          </SpaceBetween>
        </div>
      </div>
      <div style={{background: awsui.colorBackgroundCellShaded, width: "100%", paddingTop: "40px", paddingBottom: "40px"}}>
        <div className="body-content">
          <div style={{
            textAlign: "left",
          }}>
            <h3>Round 3</h3>
          </div>
          <SpaceBetween direction="vertical" size="xl">
            <PhotoProvider maskOpacity={0.8} pullClosable >
              <Grid
                disableGutters
                gridDefinition={
                  round3Images.keys().map(() => {
                    return { colspan: { default: 6, xs: 4, m: 3 } }
                  })
                }
              >  
                {round3Images.keys().map(image => (
                  <div className="liivery-grid-container">
                    <Box textAlign="center">
                      <PhotoView src={round3Images(image)}>
                        <img
                          src={round3Images(image)}
                          alt={`image-${image}`}
                          key={image}
                          style={{
                            borderRadius: "10px",
                            width: "95%"
                          }}
                        />
                      </PhotoView>
                    </Box>
                  </div>
                ))}
              </Grid>          
            </PhotoProvider>
          </SpaceBetween>
        </div>
      </div>
      <div style={{background: awsui.colorBackgroundCellShaded, width: "100%", paddingTop: "40px", paddingBottom: "40px"}}>
        <div className="body-content">
          <div style={{
            textAlign: "left",
          }}>
            <h3>Round 4</h3>
          </div>
          <SpaceBetween direction="vertical" size="xl">
            <PhotoProvider maskOpacity={0.8} pullClosable >
              <Grid
                disableGutters
                gridDefinition={
                  round4Images.keys().map(() => {
                    return { colspan: { default: 6, xs: 4, m: 3 } }
                  })
                }
              >  
                {round4Images.keys().map(image => (
                  <div className="liivery-grid-container">
                    <Box textAlign="center">
                      <PhotoView src={round4Images(image)}>
                        <img
                          src={round4Images(image)}
                          alt={`image-${image}`}
                          key={image}
                          style={{
                            borderRadius: "10px",
                            width: "95%"
                          }}
                        />
                      </PhotoView>
                    </Box>
                  </div>
                ))}
              </Grid>          
            </PhotoProvider>
          </SpaceBetween>
        </div>
      </div>
    </>
  );
}